/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Anil Kumar Mula",
  logo_name: "Anil Kumar Mula",
  nickname: "Anil",
  subTitle:
    "A passionate individual who always thrive to work on full stack development with focus on front end using React. I have good problem solving skills and programming skills.",
  resumeLink:
    "https://drive.google.com/file/d/1SmL3m_yNZqWUD7WerBWOKJLg9CXUrJ4L/view?usp=sharing",

  portfolio_repository: "https://github.com/anilmula.github.io",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/anilmula",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://linkedin.com/in/anil-kumar-mula-56729475",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },

  {
    name: "Gmail",
    link: "mailto:anilreddymula@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },

  {
    name: "Facebook",
    link: "https://www.facebook.com/anilreddy.mula",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/anil_mula/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React",
        "⚡ Creating application backend in Node, Express & Knex",
        "⚡ Proving authentication to the Applications",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },

        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [],
};

const degrees = {
  degrees: [
    {
      title: "School of Information Technology",
      subtitle: "M.Tech. in Software Engineering",
      logo_path: "iiitk_logo.png",
      alt_name: "JNTU Hyderabad",
      duration: "2009-2011",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS etc.",
        "⚡ Apart from this, I have done course Full Stack Development.",
        "⚡ Received merit scholarship.",
      ],
      website_link: "http://jntuh.ac.in",
    },
    {
      title: "Kamala Institute of Technology and Sciences",
      subtitle: "B.Tech. in Computer Science and Engineering",
      logo_path: "kits_logo.png",
      alt_name: "JNTU Hyderabad",
      duration: "2002-2006",
      descriptions: [
        "⚡ I have studied basic programming like C, Linux Programming, PL/SQL etc.",
        "⚡ Apart from this, I have studied subjects like Operating Systems, Compiler design, Computer Organization etc.",
        "⚡ Proved best in programming.",
      ],
      website_link: "https://kitssingapuram.ac.in",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Full Stack Web Development Course",
      subtitle: "Hack Your Future Mentors",
      logo_path: "hyf_logo.png",
      certificate_link: "https://www.hackyourfuture.dk/",
      color_code: "#8C151599",
    },
    {
      title: "Programming for Everybody (Python)",
      subtitle: "CHARLES SEVERANCE",
      logo_path: "rice_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1SHJ7-ZDUfVWbDsbe-REBrvJy3X7xDLoR/view?usp=sharing",
      alt_name: "University of Michigan",
      color_code: "#8C151599",
    },
    {
      title: "An introduction to interactive programming in Python",
      subtitle: "JOE WARREN",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/19JqaJ4Bu3VRC47t7IP1iwJ63KP82Inuz/view?usp=sharing",
      alt_name: "RICE UNIVERSITY",
      color_code: "#8C151599",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description: "",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [{}],
    },
    {
      title: "Internships",
      experiences: [],
    },
    {
      title: "Volunteerships",
      experiences: [],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I have completed all these projects as part of my course in HackYourFuture. Mealshare project is a mini project and Study group management system in the final project",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "circlephoto.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. ",
  },

  addressSection: {
    title: "Address",
    subtitle: "copenhegen",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 71339479",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
